import React from "react";
import notfound from "../assets/images/notfound.png";
import Header from "../front/inc/Header";
import Footer from "../front/inc/Footer";

const NotFound = () => {
  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      minHeight: "100vh" 
    }}>
      <Header />
      <section
        className="not-found-section"
        style={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "60px 20px",
        }}
      >
        <h1 style={{ fontWeight: "700", color: "#2ec2ad" }}>
          404 - Page Not Found
        </h1>

        <p style={{ color: "#555" }}>
          Sorry, the page you are looking for does not exist or has been moved.
        </p>
      </section>
      <Footer mainFooter={true} />
    </div>
  );
};

export default NotFound;